'use client';
import Image from 'next/image';
import PropTypes from 'prop-types';
import {
  StepHeaderContent,
  StepTitle,
  StepDescription,
  StyledDesktopImage,
  StyledMobileImage,
} from './styles';

export const ScreeningStepHeader = ({ title, description, image }) => (
  <StepHeaderContent>
    {image?.src && (
      <StyledMobileImage>
        <Image src={image.src} alt={image.alt} width={281} height={187} />
      </StyledMobileImage>
    )}
    <StepTitle>{title}</StepTitle>
    <StepDescription>{description}</StepDescription>
    {image?.src && (
      <StyledDesktopImage>
        <Image src={image.src} alt={image.alt} width={384} height={256} />
      </StyledDesktopImage>
    )}
  </StepHeaderContent>
);

ScreeningStepHeader.displayName = 'ScreeningStepHeader';
ScreeningStepHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.object,
};
